/**
 * Class description
 *
 * Created: 2019-08-30
 * @author jonas
 */
import {Timeline} from "gsap";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {ImmortalFruits} from "../../ImmortalFruits";
import {ImmortalFruitsGameMode} from "../../ImmortalFruitsGameMode";

export class ReelStart implements GameRoundPresentation {
    stagger?: number;
    abortStagger?: number;
    private readonly _reelId: number;

    /**
     * @constructs
     * @param reelId
     * @param stagger
     * @param abortStagger
     */
    constructor(reelId: number, stagger?: number, abortStagger?: number) {
        this._reelId = reelId;
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }

    /**
     * @inheritDoc
     * @param data
     */
    public getAnimation(data: ParsedServerData): Timeline | null {
        // making sure reels do not spin when next mode is gamble.
        if (data.nextMode === ImmortalFruitsGameMode.GAMBLE) {
            return null;
        }
        return ImmortalFruits.timelineReelsController.startSpin(this._reelId);
    }
}